import {
    LOG_IN_REQUEST,
    LOG_IN_SUCCESS,
    LOG_IN_FAILURE,
    LOG_OUT,
    CHECK_USERNAME_REQUEST,
    CHECK_USERNAME_SUCCESS,
    CHECK_USERNAME_FAILURE,
    STORE_SECURITY_CODE,
    DELETE_SECURITY_CODE,
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE,
    GET_SUPPORT_CONNECTION_REQUEST,
    GET_SUPPORT_CONNECTION_SUCCESS,
    GET_SUPPORT_CONNECTION_FAILURE,
    CONNECT_TO_SUPPORT_VPN_REQUEST,
    CONNECT_TO_SUPPORT_VPN_SUCCESS,
    CONNECT_TO_SUPPORT_VPN_FAILURE
} from './authActionTypes';

export const login = (username, password, history, location) => ({
    type: LOG_IN_REQUEST,
    payload: {
        username,
        password,
        history,
        location
    }
});

export const loginSuccess = (username, isAdmin, permissions) => ({
    type: LOG_IN_SUCCESS,
    payload: {
        username,
        isAdmin,
        permissions
    }
});

export const loginError = () => ({
    type: LOG_IN_FAILURE,
    payload: new Error(),
    error: true
});

export const logOut = (isAdmin, history) => ({
    type: LOG_OUT,
    payload: {
        isAdmin,
        history
    }
});

export const checkUsernameRequest = (username, history, location) => ({
    type: CHECK_USERNAME_REQUEST,
    payload: {
        username,
        history,
        location
    }
});

export const checkUsernameSuccess = (username, email) => ({
    type: CHECK_USERNAME_SUCCESS,
    payload: {
        username,
        email
    }
});

export const checkUsernameFailure = () => ({
    type: CHECK_USERNAME_FAILURE,
    payload: new Error(),
    error: true
});

export const storeSecurityCode = securityCode => ({
    type: STORE_SECURITY_CODE,
    payload: { securityCode }
});

export const deleteSecurityCode = () => ({ type: DELETE_SECURITY_CODE });

export const resetPasswordRequest = (username, securityCode, password, history, location) => ({
    type: RESET_PASSWORD_REQUEST,
    payload: {
        username,
        securityCode,
        password,
        history,
        location
    }
});

export const resetPasswordSuccess = () => ({ type: RESET_PASSWORD_SUCCESS });

export const resetPasswordFailure = () => ({
    type: RESET_PASSWORD_FAILURE,
    payload: new Error(),
    error: true
});

export const getSupportConnectionRequest = () => ({ type: GET_SUPPORT_CONNECTION_REQUEST });

export const getSupportConnectionSuccess = (licence, licenceStatus, ip, vpnStatus) => ({
    type: GET_SUPPORT_CONNECTION_SUCCESS,
    payload: {
        licence,
        licenceStatus,
        ip,
        vpnStatus
    }
});

export const getSupportConnectionFailure = () => ({
    type: GET_SUPPORT_CONNECTION_FAILURE,
    payload: new Error(),
    error: true
});

export const connectToSupportVPNRequest = () => ({ type: CONNECT_TO_SUPPORT_VPN_REQUEST });

export const connectToSupportVPNSuccess = (ip, vpnStatus) => ({
    type: CONNECT_TO_SUPPORT_VPN_SUCCESS,
    payload: {
        ip,
        vpnStatus
    }
});

export const connectToSupportVPNFailure = () => ({
    type: CONNECT_TO_SUPPORT_VPN_FAILURE,
    payload: new Error(),
    error: true
});
